import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "label", "readonly", "disabled", "children"],
    _excluded2 = ["onItemClick", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Option
 */
import { useOption, useSelectInstance } from '@tencent/glue-react-select';
import React, { useCallback } from 'react';
import { ViewSelectOption } from '../../views/ViewSelectOption';
export function Option(props) {
  var value = props.value,
      label = props.label,
      readonly = props.readonly,
      disabled = props.disabled,
      children = props.children,
      extra = _objectWithoutProperties(props, _excluded);

  var _useOption = useOption({
    value: value,
    label: label,
    disabled: disabled,
    readonly: readonly
  }),
      onItemClick = _useOption.onItemClick,
      id = _useOption.id,
      info = _objectWithoutProperties(_useOption, _excluded2);

  var _useSelectInstance = useSelectInstance(),
      multiple = _useSelectInstance.multiple;

  var clickHandle = useCallback(function (e) {
    onItemClick();

    if (multiple) {
      e.stopPropagation();
    }
  }, [multiple]);
  return React.createElement(ViewSelectOption, _objectSpread(_objectSpread(_objectSpread({}, extra), {}, {
    key: id,
    title: label,
    multiple: multiple,
    "data-type": "select-option",
    "data-option-id": id
  }, info), {}, {
    onClick: clickHandle
  }), children);
}